import React from 'react';
import { ReactComponent as ChatbotReportsIcon } from "../../../../assets/ChatbotReportsSvgs/ChatbotReportsIcon.svg";
import { ReactComponent as CautionIconChatbotReportsIcon } from "../../../../assets/ChatbotReportsSvgs/CautionResponseChatbotReportsIcon.svg";
import { ReactComponent as GrowthMetricsIcon } from "../../../../assets/ChatbotReportsSvgs/MetricsSvgs/GrowthMetricsIcon.svg";
// import { MetricsDataInterface } from 'interface/ReportsChatbotInterface';
import MetricsMessageBubbleLoader from './MetricsMessageBubbleLoader';
import './style.scss';
import { MetricsDataInterface } from '../../../../interface/ReportsChatbotInterface';

interface MetricsMessageBubbleProps {
    sender?: 'user' | 'ai';
    metricsData?: MetricsDataInterface | null | undefined;
    isLoadingMetricsData?: boolean;
    isFailureMetricsData?: boolean;
    apiFailureResponeMetricsData?: string;
    userInitial?: string;
    onRetry?: () => void;
}

const MetricsMessageBubble: React.FC<MetricsMessageBubbleProps> = ({
    sender: senderProp,
    isLoadingMetricsData,
    metricsData,
    isFailureMetricsData,
    apiFailureResponeMetricsData,
    userInitial = '',
    onRetry
}) => {
    const sender = senderProp ?? 'user';

    if (isLoadingMetricsData) {
        return <MetricsMessageBubbleLoader />;
    }

    const showFailure = isFailureMetricsData ?? false;
    const showSalesOverview = !showFailure && metricsData?.metrics;

    const currencySymbol = metricsData?.currency?.symbol ?? metricsData?.metrics?.currency ?? '';
    const m = metricsData?.metrics;

    return (
        <div className={`metrics-message-row ${sender}-message`}>
            <div className={`metrics-message-bubble ${showSalesOverview ? 'metrics-sales-overview-card' : ''}`}>
                {showFailure ? (
                    <>
                        <CautionIconChatbotReportsIcon className="metrics-caution-icon" />
                        <span className="metrics-failure-text">
                            {apiFailureResponeMetricsData}
                        </span>
                        {onRetry && (
                            <button className="metrics-retry-btn" type="button" onClick={onRetry}>
                                Retry
                            </button>
                        )}
                    </>
                ) : showSalesOverview && m ? (
                    <div className="metrics-sales-overview-content">
                        <div className="metrics-sales-overview-title">Sales Overview</div>
                        <div className="metrics-sales-overview-row">
                            <span className="metrics-sales-overview-label">{m.label_left ?? 'Today'}</span>
                            <span className="metrics-sales-overview-value">
                                {m.today_sales}
                            </span>
                        </div>
                        <div className="metrics-sales-overview-row">
                            <span className="metrics-sales-overview-label">{m.label_right ?? 'Yesterday'}</span>
                            <span className="metrics-sales-overview-value">
                                {m.yesterday_sales}
                            </span>
                        </div>
                        <div className={`metrics-sales-overview-delta ${m.is_growth ? 'metrics-delta-growth' : 'metrics-delta-decline'}`}>
                            <GrowthMetricsIcon className="metrics-delta-icon" />
                            <span>
                                <span className="metrics-delta-percent">
                                    {m.percentage_delta} %
                                </span>
                                {m.comparison?.summary && (
                                    <span className="metrics-delta-growth-decline-text"> {m.comparison.summary}</span>
                                )}
                            </span>
                        </div>
                    </div>
                ) : (
                    <span>{metricsData?.metrics?.today_sales ?? ''}</span>
                )}
            </div>
        </div>
    );
};

export default MetricsMessageBubble;
